var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var EmailGptResponse = /** @class */ (function (_super) {
    __extends(EmailGptResponse, _super);
    function EmailGptResponse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.message = null;
        return _this;
    }
    EmailGptResponse.prototype.replaceCandidateNamePlaceholders = function (candidateName) {
        this.message = this.message.replace(/{candidate_name}/g, candidateName);
    };
    return EmailGptResponse;
}(Entity));
export { EmailGptResponse };
